'use client';

import { useFieldContext } from '@/lib/form';
import { Input } from '@sapling/ui/components/ui/input';
import { Label } from '@sapling/ui/components/ui/label';
import { FieldError, fieldErrorId } from './field-error';

export function NumberField({
  label,
  placeholder,
  min,
  max,
}: {
  label: string;
  placeholder?: string;
  min?: number;
  max?: number;
}) {
  const field = useFieldContext<number>();
  const hasErrors =
    field.state.meta.isTouched && field.state.meta.errors.length > 0;

  return (
    <div>
      <Label htmlFor={field.name}>{label} *</Label>
      <Input
        id={field.name}
        type="number"
        min={min}
        max={max}
        value={field.state.value}
        onChange={(e) =>
          field.handleChange(
            e.target.value === ''
              ? ('' as unknown as number)
              : Number(e.target.value),
          )
        }
        onBlur={field.handleBlur}
        placeholder={placeholder}
        aria-invalid={hasErrors}
        aria-describedby={hasErrors ? fieldErrorId(field.name) : undefined}
      />
      <FieldError errors={field.state.meta.errors} fieldName={field.name} />
    </div>
  );
}
